import { axiosInstance } from "./config";


export const getAllCatelogs = async () => {
  const res = await axiosInstance.get('/catelogs');
  return res.data;
};

export const createCatelog = async (data) => {
  const res = await axiosInstance.post('/catelogs', data);
  return res.data;
};

export const updateCatelog = async (id, data) => {
  const res = await axiosInstance.post(`/catelogs/${id}`, data);
  return res.data;
};

export const deleteCatelog = async (id) => {
  const res = await axiosInstance.delete(`/catelogs/${id}`);
  return res.data;
};
export const getCatelog = async (id) => {
  const res = await axiosInstance.get('/catelogs/'+id);
  return res.data;
};
export const getBestProducts = async (id) => {
  const res = await axiosInstance.get(`/catelog/products/${id}`);
  return res.data;
};